import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { ToastContainer } from 'react-toastify';
import NoSesssionPage from '../../Layouts/Shared/_NoSesssionPage';
import background from '../../Assets/Images/login/background5.jpg';

export default function NoSesssionAuthPage({ children, title }) {
    const { t } = useTranslation();
    const BRAND_COLOR = "#013682";
    document.title = title;

    return (
        <NoSesssionPage title={title}>
            <div className="auth-main-wrapper">
                <ToastContainer position="top-center" autoClose={3000} />
                <Container fluid className="p-0">
                    <Row className="g-0 min-vh-100">
                        {/* Sol Panel: Görsel Alan */}
                        <Col lg={7} xl={8} className="d-none d-lg-flex align-items-center justify-content-center position-relative overflow-hidden">
                            <div className="auth-bg-overlay"></div>
                            <div className="auth-bg-image" style={{ backgroundImage: `url(${background})` }}></div>
                            <div className="position-relative z-index-10 text-white p-5 w-75">
                                <h1 className="display-4 fw-bold mb-4">{t('layout.no-sesssion-auth-page.header')}<br />{t('layout.no-sesssion-auth-page.subtitle')}</h1>
                                <p className="lead opacity-75">{t('layout.no-sesssion-auth-page.text')}</p>
                            </div>
                        </Col>

                        {/* Sağ Panel: Form İçeriği */}
                        <Col lg={5} xl={4} className="d-flex flex-column align-items-center justify-content-center bg-white shadow-lg">
                            <div className="w-100 p-4 p-md-5">
                                {children}

                                {/* Ortak Footer */}
                                <div className="mt-5 text-center text-muted">
                                    <p className="small mb-0" style={{ fontSize: '0.75rem' }}>
                                        {t('footer.copyright.product-name')} &copy; {new Date().getFullYear()} <br />
                                        <span className="fw-bold text-dark">{t('footer.copyright.company-name')}</span>
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <style>
                {`
                    .auth-main-wrapper { background-color: #f8fafc; min-height: 100vh; }
                    .auth-bg-image { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-size: cover; background-position: center; }
                    .auth-bg-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(135deg, ${BRAND_COLOR}EE 0%, #001532EE 100%); z-index: 1; }
                    .z-index-10 { z-index: 10; }
                    
                    .corporate-input-group { border: 2px solid #eef2f6; border-radius: 10px; overflow: hidden; transition: all 0.3s ease; }
                    .corporate-input-group:focus-within { border-color: ${BRAND_COLOR}; box-shadow: 0 0 0 4px rgba(1, 54, 130, 0.1); }
                    .corporate-input-group .form-control { border: none !important; box-shadow: none !important; padding: 12px; }
                    .corporate-input-group .input-group-text { border: none !important; color: ${BRAND_COLOR}; }

                    .corporate-btn { background-color: ${BRAND_COLOR} !important; border: none !important; padding: 14px !important; border-radius: 10px !important; font-weight: 600 !important; transition: all 0.3s ease !important; }
                    .corporate-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(1, 54, 130, 0.3) !important; }
                    
                    .cursor-pointer { cursor: pointer; }
                `}
            </style>
        </NoSesssionPage>
    );
}